import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-order",
  "use": "icon-order-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-order\"><path d=\"M320 480h384v-64H320zm0 128h256v-64H320zm0 128h256v-64H320z\" /><path d=\"M832 160H704V96H320v64H192c-19.2 0-32 12.8-32 32v704c0 19.2 12.8 32 32 32h640c19.2 0 32-12.8 32-32V192c0-19.2-12.8-32-32-32zm-448 0h256v64H384v-64zm416 704H224V224h96v64h384v-64h96v640z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol